import React from "react";
import {
  makeStyles,
  Card,
  CardContent,
  Button,
  Typography,
  Divider,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 698,
    maxHeight: 450,
    textAlign: "center",
    "&:hover": {
      boxShadow: "0px 0px 66px -16px rgba(0,0,0,0.71)",
    },
  },
  title: {
    marginTop: "3.5rem",
    [theme.breakpoints.only("xs")]: {
      marginTop: "1.5rem",
    },
  },
  subText: {
    margin: "1.437rem 0 1.562rem 0",
  },
  btn: {
    [theme.breakpoints.only("md")]: {
      padding: ".7rem 9rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: ".7rem 10rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: ".7rem 5rem",
      margin: "2.5rem 0",
    },
    padding: ".7rem 13rem",
    margin: "5rem 0 6.312rem 0",
    textTransform: "none",
    backgroundColor: "#026FC2",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#0252c2",
      color: "#ffffff",
    },
  },
}));

export default function PricingCard({ btnName, title, text }) {
  const classes = useStyles();

  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <Typography variant="h1" color="primary" className={classes.title}>
          {title}
        </Typography>
        <Typography className={classes.subText} variant="h3" color="secondary">
          {text}
        </Typography>
      </CardContent>
      <Divider />
      <Button variant="outlined" color="primary" className={classes.btn}>
        {btnName}
      </Button>
    </Card>
  );
}

PricingCard.defaultProps = {
  btnName: "Get Started",
};
